<template>
  <!-- 智慧景区 -->
  <div class="scheme_container">
    <div class="scheme_wrap">
      <div class="title_wrap">{{ pageData.title }}</div>
      <div class="content_wrap">
        <div class="article_box unify_article">
          {{ pageData.text.text1 }}
        </div>
        &nbsp;
        <div
          class="img_wrap"
          v-for="(item, index) in pageData.imgArr"
          :key="`${index}-img`"
        >
          <img :src="item.imgSrc" :alt="item.alt" />
          <p class="img_caption" v-if="item.caption">{{ item.caption }}</p>
        </div>
        &nbsp;
        <div class="article_wrap" v-for="(item, index) in pageData.text.textArr" :key="index">
          <div class="subtitle">{{ item.textTitle }}</div>
          <div
            class="text unify_article"
            v-for="(itemText, indexText) in item.textContent"
            :key="`${index}-${indexText}`"
          >
            {{ itemText }}
          </div>
          &nbsp;
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pageData: {
        title: '智慧景区',
        text: {
          text1:
            '瑞谦智慧景区解决方案依托物联网、云计算、大数据等技术能力，建设统一管控平台，实现景区数据透明化、运行数字化、服务精细化，全面提升景区的安全保障、运营效率与游客体验。',
          textArr: [
            {
              textTitle: '数据可视化监测',
              textContent: [
                '通过视频监控、客流统计、智慧灯杆、环境监测等多元设备，实时采集游客与车辆数据。',
                '管理中心可在大屏上直观查看客流热力、饱和度与预警信息，实现“看得见”的景区态势。'
              ]
            },
            {
              textTitle: '拥堵预警与秩序管控',
              textContent: [
                '系统对重点区域进行密度阈值判断，超出阈值立即推送疏导建议和广播提示。',
                '结合路网、停车场等数据，动态调整引流路线，保障游客动线安全顺畅。'
              ]
            },
            {
              textTitle: '服务体验与应急响应',
              textContent: [
                '游客可通过导览大屏、H5、小程序了解景点介绍、活动信息、购票与投诉渠道，提升自助服务能力。',
                '当突发事件发生，游客扫描救援码或通过求助设备即可快速定位，指挥中心联动最近的安保和救援力量，实现分钟级响应。'
              ]
            }
          ]
        },
        imgArr: [
          {
            imgSrc: require('@/assets/img/solution/smart-scenic.jpg'),
            alt: '智慧景区',
            caption: '数字化景区全局监测'
          }
        ]
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/views/solution/unifyStyle.scss';

.img_caption {
  margin-top: 10px;
  font-size: 14px;
  color: rgba(102, 102, 102, 0.9);
  text-align: center;
}
</style>

